<template>
  <div class="record" :class="[type === 'show' ? 'show' : '', 'record-theme-' + theme]" :style="{backgroundImage: noneInput && type ? 'none' : themeList[currentTheme]['--record-content-bg'], padding: noneInput && type ? '0' : '24px'}" @click="handleMouse">
    <div class="theme-book-bg" v-if="theme == 'book'">
      <i v-for="n in 9" :key="n"></i>
    </div>
    <div class="book-title" v-if="bookTitle">{{ bookTitle }}</div>
    <div v-if="!richText && type !== 'show' && (!noneInput || (noneInput && !type))" class="image_steerBorder_bg" />
    <!-- <div id="textarea"
      ref="textarea"
      @paste.prevent
      @dragover.prevent
      @input="changeRecord"
      :contenteditable="isShowAnswer"
      @beforeinput="beforeInput"
      :data-input-stats="dontStats ? undefined : 'input_txt'"
      :data-stats-var="statsVar"
      :data-stats-note="statsNote"
      v-if="richText">
      <span id="textNode" style="font-size: 14px; color: #383838">{{text}}</span>
    </div> -->
    <div v-if="richText" style=" margin-bottom: 50px;" class="inputContent">
      <my-editor
        class="simulateTextarea"
        :class="{noHasText: record.length === 0}"
        :data-input-stats="dontStats ? undefined : 'input_txt'"
        :data-stats-var="statsVar"
        :data-stats-note="statsNote"
        :readonly="!isShowAnswer"
        :voiceEntering="record"
        :voiceEnteringIng="recordStart"
        :contentPadding="15"
        placeholder="可录音或键盘输入答案"
        @input="changeRecord"
        :lastAnswer="text.replace(/<p/g, '<span')"
      />
    </div>
    <div v-if="!richText && type !== 'show' && (!noneInput || (noneInput && !type))" style="border: 1px solid #cccc; margin-bottom: 50px;" class="inputContent">
      <my-editor
        class="simulateTextarea"
        :class="{noHasText: record.length === 0}"
        :dataInputStats="dontStats ? undefined : 'input_txt'"
        :dataStatsVar="statsVar"
        :dataStatsNote="statsNote"
        :readonly="!isShowAnswer"
        :voiceEntering="record"
        :voiceEnteringIng="recordStart"
        :contentPadding="15"
        placeholder="可录音或键盘输入答案"
        @input="changeRecord"
      />
    </div>

    <!-- <div class="simulateTextarea"
      :data-input-stats="dontStats ? undefined : 'input_txt'"
      :data-stats-var="statsVar"
      :data-stats-note="statsNote"
      :class="{noHasText: record.length === 0}"
      :contenteditable="isShowAnswer"
      :ref="'textareaInput'+ id"
      v-if="!richText && type !== 'show' && (!noneInput || (noneInput && !type))"
      type="text"
      :disabled="!isShowAnswer"
      placeholder="可录音或键盘输入答案"
      v-model="record"
      @paste.prevent @dragover.prevent
      @input="changeRecord"
    ></div> -->
    <div
      class="button"
      :class="type === 'show' ? 'show' : ''"
      >
      <img class="steer_button" :src="require('@/assets/exam/button_kuang.png')" alt="">
      <div
        class="collect"
        @mousedown="mouseStart"
        @mouseup="mouseEnd"
        @mousemove="mouseMove"
        @dblclick="dblclick"
        :class="noneInput && recordStart ? 'long_press' : ''">
        <img
          src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624eaa56ce32f/594796574.png"
          alt=""
        />
        <span v-if="!recordStart">{{noneInput ? '按住录入' : '点击录音'}}</span>
        <span v-else>{{noneInput ? '录入中' : '停止录音'}}</span>
      </div>
      <div class="submit" :style="{borderRadius: type==='show' ? '20px' : ''}" @click="submit" v-if="(type === 'singleClass' || type === 'show') && !noneInput">提交</div>
      <div class="submit" v-if="type === 'add'" @click="add">{{buttonText}}</div>
      <div class="submit" v-if="type === 'del'" @click="del" >删除</div>
    </div>
  </div>
</template>

<script>
import MyEditor from '@/component/Editor/Editor.vue';
import { postProcessStats } from '@/utils/stats'
import { mapMutations } from 'vuex'
import { isFunction } from 'lodash'

export default {
  props: {
    id: {
      type: Number,
      value: 1
    },
    type: {
      type: String,
      value: ''
    },
    submitList: {
      type: Array,
      value: () => {
        return []
      }
    },
    toHtml: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    isShowAnswer: {
      type: Boolean,
      default: false
    },
    richText: {
      type: Boolean,
      default: false
    },
    noneInput: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'default'
    },
    bookTitle: {
      type: String,
      default: ''
    },
    dontStats: {
      type: Boolean,
      default: false
    },
    statsVar: {
      type: String,
      default: ''
    },
    statsNote: {
      type: String,
      default: ''
    },
    recordNote: {
      type: String,
      default: ''
    },
    recordNoteEnd: {
      type: String,
      default: ''
    }
  },
  components: {
    MyEditor
  },
  data() {
    return {
      textChange: false,
      recognition: '',
      record: '',
      recordArr: [''],
      oldRecord: '',
      recordStart: false,
      errorMessage: '没权限',
      themeList: [
        {
          '--button-bg-color': '#4F6A5A',
          '--record-button-bg': '#007a93',
          '--record-content-bg': 'url(' + require('@/assets/exam/theme0/k_y@2x.png') + ')',
        },
        {
          '--button-bg-color': '#5B4069',
          '--record-button-bg': '#63496F',
          '--record-content-bg': 'url(' + require('@/assets/exam/theme1/k_y@2x.png') + ')',
        },
      ],
      currentTheme: 0,
      mouseTimer: 0,
      recordBoxs: [],
      // range: undefined,
      // dbClick: false,
      // timer: null
      voiceEnteringIng: false
    };
  },
  watch: {
    recordStart(value) {
      this.$emit(value ? 'recordStart' : 'recordEnd')
      if (this.$props.noneInput === false) {
        this.$props.dontStats || postProcessStats({
          event: value ? 'start_record' : 'end_record',
          note: this.$props.recordNote,
          statsVar: this.$props.statsVar,
        })
      } else {
        if (!value && !('recordEnd' in this.$listeners)) {
          this.$props.dontStats || postProcessStats({
            event: 'clickinput_audio',
            note: this.$props.recordNoteEnd || this.$props.recordNote,
            statsVar: this.$props.statsVar
          })
        }
      }
    },
    'recordArr': {
      handler() {
        // console.log(this.recordArr)
      },
      deep: true
    },
    'record': {
      handler() {
        if (!this.textChange && this.recordStart && this.$refs['textareaInput' + this.id]) {
          this.$refs['textareaInput' + this.id].innerText = this.record
        }
        if (!this.type && !this.recordStart) {
          this.recordArr[0] = this.record
        }
        if (this.noneInput && this.recordStart && this.type && 'show_singleClass'.includes(this.type) > -1) {
          if (this.type === 'singleClass') {
            const box = document.getElementsByClassName('submitList')
            if (box.scrollTop) {
              box.scrollTop = box.scrollHeight
            } else {
              box[0].scrollTop = box[0].scrollHeight
            }
          } else {
            const obj = {
              type: 'text',
              value: this.record
            }
            this.$emit('getRecord', obj)
          }
          const title = this.toHtml ? '<font color="#fe5c2b">' + this.record + '</font>' : this.record
          this.submitList[this.submitList.length - 1].title = title
          this.$emit('update:submitList', this.submitList)
        }
      }
    },
    'text': {
      handler() {
        if (!this.richText) {
          this.record = this.text
        }
      }
    }
  },
  mounted() {
    this.recordBoxs = Object.keys(this.$parent.$refs).filter(item => {
      return item.includes('record') && this.$parent.$refs[item].length > 0
    })
    // console.log(this.$parent.$refs, this.recordBoxs)
    // eslint-disable-next-line no-undef
    if (typeof this.recognition === 'object' && this.recognition.stop) this.recognition.stop();
    const WebkitSpeechRecognition =
      window.SpeechRecognition ||
      window.webkitSpeechRecognition ||
      window.mozSpeechRecognition ||
      window.msSpeechRecognition ||
      window.oSpeechRecognition;
    this.recognition = new WebkitSpeechRecognition();
    this.recognition.continuous = true;
    this.recognition.interimResults = true;
    this.recognition.lang = 'zh-CN'; // 普通话 (中国大陆)
    this.recognition.onresult = e => {
      if (this.recordStart) {
        this.record = ''
        this.newRecord = ''
        for (const key in e.results) {
          if (Object.hasOwnProperty.call(e.results, key)) {
            const element = e.results[key];
            if (this.type) {
              this.record += element[0].transcript
            } else {
              this.record = this.recordArr[0]
              this.newRecord += element[0].transcript
              this.record += this.newRecord
            }
            this.$emit('getRecordContent', this.record)
          }
        }
      }
    };
    this.recognition.onend = e => {
      if (this.type || this.textChange) return
      // console.log(this.id, this.$refs['textareaInput' + this.id])
      this.recordArr[0] = this.record
    };
    this.recognition.onerror = event => {
      if (event.error === 'not-allowed') {
        this.errorMessage = '请打开录音权限';
      }
      // this.$message.error(this.errorMessage);
      this.error = true;
      console.log(event);
    };
    // this.autoTextarea(this.$refs.textareaInput, 20, 100000)
  },
  created() {
    this.initTheme()
  },
  methods: {
    ...mapMutations(['setEditorConetnt']),
    beforeInput(el) {
      if (this.type !== 'show') {
        document.execCommand('ForeColor', false, '#FE5C2B')
      }
    },
    handleMouse() {
      if (!this.isShowAnswer) {
        this.$message({
          message: '看完视频后开始答题',
          type: 'warning'
        })
      }
    },
    handleInput(el) {
      const obj = {
        type: 'text',
        value: el.target.innerText
      }
      this.$emit('getRecord', obj)
    },
    add() {
      const obj = {
        type: 'buttonAdd',
        value: this.record
      }
      this.$emit('getRecord', obj)
    },
    del() {
      const obj = {
        type: 'buttonDel'
      }
      this.$emit('getRecord', obj)
    },
    mouseStart() {
      // console.log('*********')
      if (this.$parent.steerObj) return
      if (this.error) {
        this.$message.error(this.errorMessage);
        this.recordStart = false;
        return;
      }
      if (this.isShowAnswer) {
        clearTimeout(this.mouseTimer)
        this.mouseTimer = setTimeout(() => {
          if (this.recordBoxs.length > 0) {
            this.recordBoxs.forEach(item => {
              if (Number(item.split('record')[1]) === this.id) {
                this.$parent.$refs[item][0].recordStart = !this.$parent.$refs[item][0].recordStart
                // console.log(Number(item.split('record')[1]), this.id)
                if (!this.$parent.$refs[item][0].recordStart) {
                  if (this.$parent.$refs[item][0].noneInput) return
                  this.$parent.$refs[item][0].recordStart = false
                  if (this.$parent.$refs[item][0].recognition.stop && isFunction(this.$parent.$refs[item][0].recognition.stop)) {
                    this.$parent.$refs[item][0].recognition.stop()
                  }
                  // console.log(item.split('record')[1], this.id, this.$refs)
                  this.$parent.$refs[item][0].recordArr[0] = this.$refs['textareaInput' + Number(item.split('record')[1])].innerText
                } else {
                  this.$parent.$refs[item][0].textChange = false
                  this.$parent.$refs[item][0].recognition.start()
                  this.$parent.$refs[item][0].$message.info('开始录音');
                }
              } else {
                this.$parent.$refs[item][0].recordStart = false
              }
              // console.log(Number(item.split('record')[1]), this.id, this.$parent.$refs[item][0].recordStart)
            })
          } else {
            this.recordStart = !this.recordStart
            if (!this.recordStart) return
            this.textChange = false
            this.recognition.start()
            this.$message.info('开始录音');
          }
          if (this.type && 'show_singleClass'.includes(this.type) > -1) {
            this.record = ''
            this.submitList.push({
              title: '',
              index: this.submitList.length + 1
            })
            if (this.type === 'show') {
              this.submitList[this.submitList.length - 1].isMove = true
              this.$emit('getBubbleAnswer')
            }
            this.$emit('update:submitList', this.submitList)
          }
        }, 80)
      }
    },
    mouseEnd() {
      if (this.$parent.steerObj) return
      if (this.error) {
        this.$message.error(this.errorMessage);
        this.recordStart = false;
        return;
      }
      clearTimeout(this.mouseTimer)
      if (this.noneInput) {
        // console.log(this.recordBoxs)
        if (this.recordBoxs.length > 0) {
          this.recordBoxs.forEach(item => {
            // console.log(this.$parent.$refs[item][0])
            if (!this.$parent.$refs[item][0].recordStart) return
            this.$parent.$refs[item][0].recordStart = false
            if (this.$parent.$refs[item][0].recognition.stop && isFunction(this.$parent.$refs[item][0].recognition.stop)) {
              this.$parent.$refs[item][0].recognition.stop()
            }
          })
        } else {
          this.recordStart = false
          this.recognition.stop()
        }
        if (this.record === '') {
          this.$message.info('请输入或录制您的答案')
          return
        }
        if (!this.type) {
          const obj = {
            type: 'text',
            value: this.record
          }
          this.$emit('getRecord', obj)
        }
        this.$message.info('录音完毕')
      } else {
        // console.log(this.recordStart)
        if (this.mouseTimer !== 0 && !this.recordStart) {
          // this.recognition.stop()
          this.$message.info('录音完毕')
          if (!this.type) {
            const obj = {
              type: 'text',
              value: this.record
            }
            this.$emit('getRecord', obj)
          }
        }
      }
    },
    mouseMove() {
      clearTimeout(this.mouseTimer)
      this.mouseTimer = 0
    },
    dblclick() {
      this.recordStart = false
      return false
    },
    changeRecord(value) {
      this.textChange = true
      // if (this.recordBoxs) {
      //   this.recordBoxs.forEach(item => {
      //     this.$parent.$refs[item][0].recordStart = false
      //     if (this.$parent.$refs[item][0].recognition.stop && isFunction(this.$parent.$refs[item][0].recognition.stop)) {
      //       this.$parent.$refs[item][0].recognition.stop()
      //     }
      //   })
      // }
      this.record = value
      // 缓存输入内容
      this.setEditorConetnt({ index: 0, value })
      // if (this.type !== 'show') {
      const obj = {
        type: 'text',
        value: this.record
      }
      this.$emit('getRecord', obj)
      // }
    },
    // 自动计算输入框高度
    autoTextarea(elem, extra, maxHeight) {
      if (!elem) return
      extra = extra || 0;
      var isFirefox = !!document.getBoxObjectFor || 'mozInnerScreenX' in window
      var isOpera = !!window.opera && !!window.opera.toString().indexOf('Opera')
      var addEvent = function (type, callback) {
        elem.addEventListener
          ? elem.addEventListener(type, callback, false)
          : elem.attachEvent('on' + type, callback);
      }
      var getStyle = elem.currentStyle
        ? function (name) {
          var val = elem.currentStyle[name];
          if (name === 'height' && val.search(/px/i) !== 1) {
            var rect = elem.getBoundingClientRect();

            return (
              rect.bottom -
              rect.top -
              parseFloat(getStyle('paddingTop')) -
              parseFloat(getStyle('paddingBottom')) +
              'px'
            );
          }
          return val;
        }
        : function (name) {
          return getComputedStyle(elem, null)[name];
        }
      var minHeight = parseFloat(getStyle('height'));
      elem.style.resize = 'none';
      var change = function () {
        var scrollTop
        var height
        var padding = 0
        var style = elem.style
        if (elem._length === elem.value.length) return;
        elem._length = elem.value.length;
        if (!isFirefox && !isOpera) {
          padding =
            parseInt(getStyle('paddingTop')) +
            parseInt(getStyle('paddingBottom'));
        }
        scrollTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        elem.style.height = minHeight + 'px';
        if (elem.scrollHeight > minHeight) {
          if (maxHeight && elem.scrollHeight > maxHeight) {
            height = maxHeight - padding;
            style.overflowY = 'auto';
          } else {
            height = elem.scrollHeight - padding;
            style.overflowY = 'hidden';
          }
          style.height = height + extra + 'px';
          scrollTop += parseInt(style.height) - elem.currHeight;
          document.body.scrollTop = scrollTop;
          document.documentElement.scrollTop = scrollTop;
          elem.currHeight = parseInt(style.height);
        }
      };
      addEvent('propertychange', change);
      addEvent('input', change);
      addEvent('focus', change);
      change();
    },
    submit() {
      if (!this.isShowAnswer) return
      if (this.record === '') {
        this.$message.info('请输入或录制您的答案')
        return
      }
      if (this.type !== 'show') {
        this.submitList.push({
          title: this.record
        });
        this.$emit('update:submitList', this.submitList)
        if (this.recordStart) {
          this.recognition.stop();
          this.$message.info('录音完毕');
          this.recordStart = false;
        }
      } else {
        const obj = {
          type: 'text',
          value: this.record
        }
        this.$emit('getRecord', obj)
        const textarea = this.$refs.textarea
        textarea.removeChild(textarea.childNodes[0])
      }
      this.record = ''
    },
    changeTheme(theme) {
      for (const key in theme) {
        if (Object.hasOwnProperty.call(theme, key)) {
          const element = theme[key];
          document.documentElement.style.setProperty(key, element);
        }
      }
    },
    initTheme() {
      const subjectPath = this.$route.fullPath
      const theme0 = ['innovation', 'controller', 'stormwater', 'cosmodom', 'birdFlu', 'sprout']
      if (theme0.findIndex(item => subjectPath.indexOf(item) > -1) > -1) {
        this.changeTheme(this.themeList[0])
        this.currentTheme = 0
      } else {
        this.changeTheme(this.themeList[1])
        this.currentTheme = 1
      }
    },
  }
}
</script>

<style lang="less">
.record {
  width: 100%;
  min-height: 60px;
  background-size: 100% 100%;
  padding: 24px;
  position: relative;
  margin-top: 12px;
  .image_steerBorder_bg{
    width: 100.5%;
    height: 101%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 103;
    left: -1px;
    top: -1px;
    position: absolute;
    display: none;
  }
  #textarea{
    background: #fff;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    width: 100%;
    height: 130px;
    outline: none;
    border: 1px solid #eee;
    padding: 10px;
    overflow-y: auto;
    margin-bottom: 53px;
  }
  // #textarea::-webkit-scrollbar{
  //   display: none;
  // }
  #textarea:empty:before{
    content: '可录音或键盘输入答案';
    color: gray;
  }
  #textarea:focus {
    outline: none;
  }
  > .simulateTextarea {
    font-size: 16px;
    font-weight: 400;
    color: #383838;
    line-height: 26px;
    width: 100%;
    min-height: 130px;
    margin-bottom: 53px;
    outline: none;
    border: 1px solid #eee;
    padding: 10px;
    div{
      font-size: 16px;
    }
    // transition: all 1s;
  }
  > .simulateTextarea::after {
    content: '';
    color: gray;
    font-size: 14px;
  }
  > .noHasText::after {
    content: '可录音或键盘输入答案';
  }
  >textarea::-webkit-input-placeholder{
    font-size: 14px;
    color: #999;
  }
  .editor {
    // margin-bottom: 50px;
  }
  .button{
    position: absolute;
    width: calc(100% - 40px);
    bottom: 24px;
    display: flex;
    justify-content: space-between;
    // padding: 0 5px;
    .steer_button{
      width: 110px;
      position: absolute;
      top: -4px;
      left: -8px;
      z-index: 105;
      display: none;
      border-radius: 37%;
      background: rgba(0, 0, 0, 0.15);
    }
    .collect {
      width: 90px;
      height: 36px;
      background: var(--button-bg-color);
      box-shadow: 0px 5px 6px -4px rgba(41, 54, 242, 0.31),
        inset 0px 3px 8px 0px rgba(255, 255, 255, 0.48);
      border-radius: 17px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      span {
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 17px;
      }
      > img {
        width: 20px;
        margin-right: 4px;
      }
    }
    .collect.long_press{
      background: #b5e61d;
    }
    .submit {
      cursor: pointer;
      width: 107px;
      height: 33px;
      background: #ffffff;
      box-shadow: 0px 0px 8px -4px rgba(0, 0, 0, 0.25);
      border-radius: 6px;
      border: 1px solid #d9dadc;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 400;
      color: #000000;
      line-height: 17px;
    }
  }
  .inputContent {
    min-height: 120px;
  }
}
.record.show{
  width: 100%;
  border: 0;
  border-radius: 20px;
  margin: 0 auto;
  .button {
    width: 100%;
    bottom: 0;
    position: relative;
    .collect{
      margin: 0 auto;
      .submit {
        width: 80px;
      }
    }
  }
}
.button.notext{
  width: 60px;
}
.canvas_input.record{
  >textarea{
    height: 70px;
    margin-bottom: 0;
  }
  .button{
    width: 60px;
    position: absolute;
    bottom: -40px;
    .collect>span{
      display: none;
    }
  }
}
.record.steerBorder{
  .image_steerBorder_bg{
    display: flex;
  }
  .steer_button{
    display: flex;
  }
}
.record-theme-book {
  min-height: 536px;
  padding: 24% 21% 11% !important;
  background: transparent !important;
  > .simulateTextarea {
    position: relative;
    top: -30px;
    z-index: 9;
    min-height: 266px;
    max-height: 600px;
    overflow: auto;
    margin-bottom: 0 !important;
    line-height: 33px !important;
    padding: 0 !important;
    word-break: break-all;
    background-image: repeating-linear-gradient(to bottom, transparent, transparent 31px, #666 33px);
  }
  > .button {
    bottom: 32px;
  }
  > .book-title {
    position: absolute;
    top: 60px;
    left: 0;
    width: 100%;
    text-align: center;
  }
}
.theme-book-bg {
  position: absolute;
  left: 50%;
  top: 0;
  width: 100%;
  height: 100%;
  max-width: 661px;
  transform: translateX(-50%);
  display: grid;
  grid-template-columns: 43.263757% 1fr 43.263757%;
  grid-template-rows: 24.132492% 1fr 19.400631%;
  background-color: #efefee;
  pointer-events: none;
  > i:nth-child(1) {
    background: url('~@/assets/exam/book-1.png') no-repeat left top / cover;
  }
  > i:nth-child(2) {
    background: url('~@/assets/exam/book-2.png') no-repeat top / cover;
  }
  > i:nth-child(3) {
    background: url('~@/assets/exam/book-3.png') no-repeat right top / cover;
  }
  > i:nth-child(4) {
    background: url('~@/assets/exam/book-4.png') no-repeat left / cover;
  }
  > i:nth-child(5) {
    background: url('~@/assets/exam/book-5.png') no-repeat center / cover;
  }
  > i:nth-child(6) {
    background: url('~@/assets/exam/book-6.png') no-repeat right / cover;
  }
  > i:nth-child(7) {
    background: url('~@/assets/exam/book-7.png') no-repeat left bottom / cover;
  }
  > i:nth-child(8) {
    background: url('~@/assets/exam/book-8.png') no-repeat bottom / cover;
  }
  > i:nth-child(9) {
    background: url('~@/assets/exam/book-9.png') no-repeat right bottom / cover;
  }
  &::after {
    content: '';
    position: absolute;
    left: 9px;
    top: 50%;
    width: 52px;
    height: 334px;
    transform: translateY(-50%);
    background: url('~@/assets/exam/book-pencil.png') no-repeat 0 0 / contain;
  }
}
</style>
